// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { UserStatus } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { AppManagedStateBindingRef } from "./app_managed";
import { User } from "../../user/v1/user";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * Set the icon for an app.
 * Endpoint Requirements:
 * - The icon must be a valid PNG, JPEG or WebP image.
 * - The icon must be less than 1mb in size.
 * - The icon must be a square image.
 *
 * @generated from protobuf message c1.api.app.v1.SetAppIconRequest
 */
export interface SetAppIconRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: bytes data = 2;
     */
    data: Uint8Array;
}
/**
 * @generated from protobuf message c1.api.app.v1.SetAppIconResponse
 */
export interface SetAppIconResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.UpliftAppUsersRequest
 */
export interface UpliftAppUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpliftAppUsersResponse
 */
export interface UpliftAppUsersResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppExpandMask
 */
export interface AppExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppView
 */
export interface AppView {
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * @generated from protobuf field: string parent_app_path = 2;
     */
    parentAppPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppRef
 */
export interface AppRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * The App object provides all of the details for an app, as well as some configuration.
 *
 * @generated from protobuf message c1.api.app.v1.App
 */
export interface App {
    /**
     * The ID of the app.
     *
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the App was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the App was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the App was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * The app's display name.
     *
     * @generated from protobuf field: string display_name = 5;
     */
    displayName: string;
    /**
     * The app's description.
     *
     * @generated from protobuf field: string description = 6;
     */
    description: string;
    /**
     * The ID of the Grant Policy associated with this App.
     *
     * @generated from protobuf field: string grant_policy_id = 7;
     */
    grantPolicyId: string;
    /**
     * The ID of the Revoke Policy associated with this App.
     *
     * @generated from protobuf field: string revoke_policy_id = 8;
     */
    revokePolicyId: string;
    /**
     * The URL of a logo to display for the app.
     *
     * @generated from protobuf field: string logo_uri = 9;
     */
    logoUri: string;
    /**
     * The ID of the app that created this app, if any.
     *
     * @generated from protobuf field: string parent_app_id = 10;
     */
    parentAppId: string;
    /**
     * The ID of the Certify Policy associated with this App.
     *
     * @generated from protobuf field: string certify_policy_id = 11;
     */
    certifyPolicyId: string;
    /**
     * The ID of the Account named by AccountName.
     *
     * @generated from protobuf field: string app_account_id = 12;
     */
    appAccountId: string;
    /**
     * The AccountName of the app. For example, AWS is AccountID, Github is Org Name, and Okta is Okta Subdomain.
     *
     * @generated from protobuf field: string app_account_name = 13;
     */
    appAccountName: string;
    /**
     * The URL of an icon to display for the app.
     *
     * @generated from protobuf field: string icon_url = 14;
     */
    iconUrl: string;
    /**
     * The cost of an app per-seat, so that total cost can be calculated by the grant count.
     *
     * @generated from protobuf field: int32 monthly_cost_usd = 15;
     */
    monthlyCostUsd: number;
    /**
     * A list of fields that have been edited by a user to prevent a connector from overwriting their data.
     *
     * @generated from protobuf field: google.protobuf.FieldMask field_mask = 16;
     */
    fieldMask?: FieldMask;
    /**
     * The number of users with grants to this app.
     *
     * @generated from protobuf field: int64 user_count = 17;
     */
    userCount: number;
    /**
     * Specifies if the app is a directory.
     *
     * @generated from protobuf field: bool is_directory = 18;
     */
    isDirectory: boolean;
    /**
     * The owners of the app.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.User app_owners = 19;
     */
    appOwners: User[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserIdentityMatching identity_matching = 20;
     */
    identityMatching: AppUserIdentityMatching;
    /**
     * @generated from protobuf field: bool is_manually_managed = 22;
     */
    isManuallyManaged: boolean;
    /**
     * @generated from protobuf field: bool strict_access_entitlement_provisioning = 23;
     */
    strictAccessEntitlementProvisioning: boolean;
    /**
     * @generated from protobuf field: uint32 connector_version = 24;
     */
    connectorVersion: number;
    /**
     * The ID for the default request catalog for this app.
     *
     * @generated from protobuf field: string default_request_catalog_id = 25;
     */
    defaultRequestCatalogId: string;
    /**
     * If you add instructions here, they will be shown to users in the access request form when requesting access for this app.
     *
     * @generated from protobuf field: string instructions = 26;
     */
    instructions: string;
    /**
     * When enabled, resource ownership is sourced from the connector.
     *
     * @generated from protobuf field: bool enable_connector_sourced_ownership = 27;
     */
    enableConnectorSourcedOwnership: boolean;
}
/**
 * The CreateAppRequest message is used to create a new app.
 *
 * @generated from protobuf message c1.api.app.v1.CreateAppRequest
 */
export interface CreateAppRequest {
    /**
     * Creates the app with this display name.
     *
     * @generated from protobuf field: string display_name = 1;
     */
    displayName: string;
    /**
     * Creates the app with this description.
     *
     * @generated from protobuf field: string description = 2;
     */
    description: string;
    /**
     * Creates the app with this array of owners.
     *
     * @generated from protobuf field: repeated string owners = 4;
     */
    owners: string[];
    /**
     * Creates the app with this grant policy.
     *
     * @generated from protobuf field: string grant_policy_id = 5;
     */
    grantPolicyId: string;
    /**
     * Creates the app with this revoke policy.
     *
     * @generated from protobuf field: string revoke_policy_id = 6;
     */
    revokePolicyId: string;
    /**
     * Creates the app with this certify policy.
     *
     * @generated from protobuf field: string certify_policy_id = 7;
     */
    certifyPolicyId: string;
    /**
     * Creates the app with this monthly cost per seat.
     *
     * @generated from protobuf field: int32 monthly_cost_usd = 8;
     */
    monthlyCostUsd: number;
    /**
     * This flag enforces a provisioning mode where the access entitlement is always included in the provisioning flow, if the app user doesn't exist
     *
     * @generated from protobuf field: bool strict_access_entitlement_provisioning = 9;
     */
    strictAccessEntitlementProvisioning: boolean;
    /**
     * Define the app user identity matching strategy for this app.
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserIdentityMatching identity_matching = 10;
     */
    identityMatching: AppUserIdentityMatching;
    /**
     * Instructions shown to users in the access request form when requesting access for this app.
     *
     * @generated from protobuf field: string instructions = 11;
     */
    instructions: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppWithConnectorRequest
 */
export interface CreateAppWithConnectorRequest {
    /**
     * The app displayName.
     *
     * @generated from protobuf field: string app_display_name = 1;
     */
    appDisplayName: string;
    /**
     * The app description.
     *
     * @generated from protobuf field: string app_description = 2;
     */
    appDescription: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3;
     */
    catalogId: string;
    /**
     * The userIds of the app owners.
     *
     * @generated from protobuf field: repeated string app_owners_ids = 4;
     */
    appOwnersIds: string[];
    /**
     * The userIds of the connector owners. If let blank, the app owners will be used as the connector owners.
     *
     * @generated from protobuf field: repeated string connector_owners_ids = 5;
     */
    connectorOwnersIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppWithUnmanagedRequest
 */
export interface CreateAppWithUnmanagedRequest {
    /**
     * The app displayName.
     *
     * @generated from protobuf field: string app_display_name = 1;
     */
    appDisplayName: string;
    /**
     * The app description.
     *
     * @generated from protobuf field: string app_description = 2;
     */
    appDescription: string;
    /**
     * The catalogId describes which catalog entry this connector is an instance of. For example, every Okta connector will have the same catalogId indicating it is an Okta connector.
     *
     * @generated from protobuf field: string catalog_id = 3;
     */
    catalogId: string;
    /**
     * The userIds of the app owners.
     *
     * @generated from protobuf field: repeated string app_owners_ids = 4;
     */
    appOwnersIds: string[];
    /**
     * The userIds of the connector owners. If let blank, the app owners will be used as the connector owners.
     *
     * @generated from protobuf field: repeated string connector_owners_ids = 5;
     */
    connectorOwnersIds: string[];
    /**
     * For promoting from an unmanaged app
     *
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingRef app_managed_state_binding_ref = 6;
     */
    appManagedStateBindingRef?: AppManagedStateBindingRef;
}
/**
 * The UpdateAppRequest message contains the app to update and the fields to update.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppRequest
 */
export interface UpdateAppRequest {
    /**
     * The app being updated in the request.
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
    /**
     * The comma-sepparated list of fields to update in the view. "display_name,description"
     * would update display name and description regardless of what values are set on the request object.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppRequest
 */
export interface GetAppRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: bool include_deleted = 2;
     */
    includeDeleted: boolean;
}
/**
 * The GetAppResponse message contains the details of the requested app in the app field.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppResponse
 */
export interface GetAppResponse {
    /**
     * The app object returned by the request
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
}
/**
 * Returns the new app's values.
 *
 * @generated from protobuf message c1.api.app.v1.CreateAppResponse
 */
export interface CreateAppResponse {
    /**
     * The created app
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
}
/**
 * Returns the updated app's new values.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppResponse
 */
export interface UpdateAppResponse {
    /**
     * The updated app
     *
     * @generated from protobuf field: c1.api.app.v1.App app = 1;
     */
    app?: App;
}
/**
 * Empty request body
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppRequest
 */
export interface DeleteAppRequest {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
}
/**
 * Empty response body. Status code indicates success.
 *
 * @generated from protobuf message c1.api.app.v1.DeleteAppResponse
 */
export interface DeleteAppResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppsRequest
 */
export interface ListAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * The ListAppsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppsResponse
 */
export interface ListAppsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1;
     */
    list: App[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Search Apps by a few properties.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppsRequest
 */
export interface SearchAppsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * A list of app IDs to remove from the results.
     *
     * @generated from protobuf field: repeated string exclude_app_ids = 4;
     */
    excludeAppIds: string[];
    /**
     * A list of app IDs to restrict the search to.
     *
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * Search for apps with a case insensitive match on the display name.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * Only return apps which are directories
     *
     * @generated from protobuf field: bool only_directories = 7;
     */
    onlyDirectories: boolean;
    /**
     * Search for apps that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 8;
     */
    policyRefs: PolicyRef[];
}
/**
 * The SearchAppsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppsResponse
 */
export interface SearchAppsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.App list = 1;
     */
    list: App[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsExpandedRequest
 */
export interface SearchAppsExpandedRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 6;
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: repeated string exclude_ids = 7;
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: repeated string ids = 8;
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef refs = 9;
     */
    refs: AppRef[];
    /**
     * @generated from protobuf field: bool only_directories = 10;
     */
    onlyDirectories: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppOwnersCount amount_of_app_owners = 11;
     */
    amountOfAppOwners: AppOwnersCount;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserStatus user_statuses = 12;
     */
    userStatuses: UserStatus[];
    /**
     * @generated from protobuf field: repeated string app_owner_ids = 13;
     */
    appOwnerIds: string[];
    /**
     * @generated from protobuf field: bool only_v2_connectors = 14;
     */
    onlyV2Connectors: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 15;
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsExpandedResponse
 */
export interface SearchAppsExpandedResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppView list = 1;
     */
    list: AppView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 4;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.MultiGetAppResponse
 */
export interface MultiGetAppResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppView list = 1;
     */
    list: AppView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.MultiGetAppRequest
 */
export interface MultiGetAppRequest {
    /**
     * @generated from protobuf field: repeated string app_ids = 1;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 2;
     */
    expandMask?: AppExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetInactiveOwnersCountsRequest
 */
export interface GetInactiveOwnersCountsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.GetInactiveOwnersCountsResponse
 */
export interface GetInactiveOwnersCountsResponse {
    /**
     * @generated from protobuf field: int64 apps_count = 1;
     */
    appsCount: number;
    /**
     * @generated from protobuf field: int64 entitlements_count = 2;
     */
    entitlementsCount: number;
    /**
     * @generated from protobuf field: int64 resources_count = 3;
     */
    resourcesCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAndOwners
 */
export interface AppAndOwners {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppView app_view = 1;
     */
    appView?: AppView;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User app_owners = 2;
     */
    appOwners: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest
 */
export interface SearchAppsWithDeactivatedOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppExpandMask expand_mask = 3;
     */
    expandMask?: AppExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse
 */
export interface SearchAppsWithDeactivatedOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppAndOwners list = 1;
     */
    list: AppAndOwners[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppSearchFilter
 */
export interface AppSearchFilter {
    /**
     * @generated from protobuf field: string query = 1;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string ids = 2;
     */
    ids: string[];
    /**
     * @generated from protobuf field: repeated string exclude_ids = 3;
     */
    excludeIds: string[];
    /**
     * @generated from protobuf field: bool only_directories = 4;
     */
    onlyDirectories: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppUserIdentityMatching
 */
export enum AppUserIdentityMatching {
    /**
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * This maps the app user to the identity by email or username.
     *
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_STRICT = 1;
     */
    STRICT = 1,
    /**
     * This maps the user to the identity by display name if we don't find a matching username or email.
     *
     * @generated from protobuf enum value: APP_USER_IDENTITY_MATCHING_DISPLAY_NAME = 2;
     */
    DISPLAY_NAME = 2
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppOwnersCount
 */
export enum AppOwnersCount {
    /**
     * @generated from protobuf enum value: NOT_SPECIFIED = 0;
     */
    NOT_SPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ZERO_APP_OWNERS = 1;
     */
    ZERO_APP_OWNERS = 1,
    /**
     * @generated from protobuf enum value: ONE_APP_OWNER = 2;
     */
    ONE_APP_OWNER = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class SetAppIconRequest$Type extends MessageType<SetAppIconRequest> {
    constructor() {
        super("c1.api.app.v1.SetAppIconRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "data", kind: "scalar", T: 12 /*ScalarType.BYTES*/, options: { "validate.rules": { bytes: { minLen: "4", maxLen: "1000000" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppIconRequest
 */
export const SetAppIconRequest = new SetAppIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SetAppIconResponse$Type extends MessageType<SetAppIconResponse> {
    constructor() {
        super("c1.api.app.v1.SetAppIconResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SetAppIconResponse
 */
export const SetAppIconResponse = new SetAppIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpliftAppUsersRequest$Type extends MessageType<UpliftAppUsersRequest> {
    constructor() {
        super("c1.api.app.v1.UpliftAppUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpliftAppUsersRequest
 */
export const UpliftAppUsersRequest = new UpliftAppUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpliftAppUsersResponse$Type extends MessageType<UpliftAppUsersResponse> {
    constructor() {
        super("c1.api.app.v1.UpliftAppUsersResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpliftAppUsersResponse
 */
export const UpliftAppUsersResponse = new UpliftAppUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppExpandMask$Type extends MessageType<AppExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "parent_app_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppExpandMask
 */
export const AppExpandMask = new AppExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppView$Type extends MessageType<AppView> {
    constructor() {
        super("c1.api.app.v1.AppView", [
            { no: 1, name: "app", kind: "message", T: () => App },
            { no: 2, name: "parent_app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppView
 */
export const AppView = new AppView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppRef$Type extends MessageType<AppRef> {
    constructor() {
        super("c1.api.app.v1.AppRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppRef
 */
export const AppRef = new AppRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class App$Type extends MessageType<App> {
    constructor() {
        super("c1.api.app.v1.App", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 6, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 7, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 9, name: "logo_uri", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 10, name: "parent_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } }, "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 11, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 12, name: "app_account_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 13, name: "app_account_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 14, name: "icon_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "field_mask", kind: "message", T: () => FieldMask, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 17, name: "user_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 18, name: "is_directory", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 19, name: "app_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 20, name: "identity_matching", kind: "enum", T: () => ["c1.api.app.v1.AppUserIdentityMatching", AppUserIdentityMatching, "APP_USER_IDENTITY_MATCHING_"] },
            { no: 22, name: "is_manually_managed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 23, name: "strict_access_entitlement_provisioning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 24, name: "connector_version", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 25, name: "default_request_catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 27, name: "enable_connector_sourced_ownership", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] }, "policy.v1.msg": { enabled: true, name: "app", keyFields: ["id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.App
 */
export const App = new App$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppRequest$Type extends MessageType<CreateAppRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "4096" } } } },
            { no: 4, name: "owners", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 6, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 7, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 8, name: "monthly_cost_usd", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "strict_access_entitlement_provisioning", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "identity_matching", kind: "enum", T: () => ["c1.api.app.v1.AppUserIdentityMatching", AppUserIdentityMatching, "APP_USER_IDENTITY_MATCHING_"] },
            { no: 11, name: "instructions", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppRequest
 */
export const CreateAppRequest = new CreateAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppWithConnectorRequest$Type extends MessageType<CreateAppWithConnectorRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppWithConnectorRequest", [
            { no: 1, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "connector_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppWithConnectorRequest
 */
export const CreateAppWithConnectorRequest = new CreateAppWithConnectorRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppWithUnmanagedRequest$Type extends MessageType<CreateAppWithUnmanagedRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppWithUnmanagedRequest", [
            { no: 1, name: "app_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "catalog_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 4, name: "app_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "connector_owners_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_managed_state_binding_ref", kind: "message", T: () => AppManagedStateBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppWithUnmanagedRequest
 */
export const CreateAppWithUnmanagedRequest = new CreateAppWithUnmanagedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppRequest$Type extends MessageType<UpdateAppRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppRequest", [
            { no: 1, name: "app", kind: "message", T: () => App, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppRequest
 */
export const UpdateAppRequest = new UpdateAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppRequest$Type extends MessageType<GetAppRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppRequest
 */
export const GetAppRequest = new GetAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppResponse$Type extends MessageType<GetAppResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppResponse
 */
export const GetAppResponse = new GetAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppResponse$Type extends MessageType<CreateAppResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppResponse
 */
export const CreateAppResponse = new CreateAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppResponse$Type extends MessageType<UpdateAppResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppResponse", [
            { no: 1, name: "app", kind: "message", T: () => App, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppResponse
 */
export const UpdateAppResponse = new UpdateAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppRequest$Type extends MessageType<DeleteAppRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppRequest
 */
export const DeleteAppRequest = new DeleteAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppResponse$Type extends MessageType<DeleteAppResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppResponse
 */
export const DeleteAppResponse = new DeleteAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppsRequest$Type extends MessageType<ListAppsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppsRequest
 */
export const ListAppsRequest = new ListAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppsResponse$Type extends MessageType<ListAppsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppsResponse
 */
export const ListAppsResponse = new ListAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsRequest$Type extends MessageType<SearchAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsRequest
 */
export const SearchAppsRequest = new SearchAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsResponse$Type extends MessageType<SearchAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => App },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsResponse
 */
export const SearchAppsResponse = new SearchAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsExpandedRequest$Type extends MessageType<SearchAppsExpandedRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsExpandedRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 7, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "amount_of_app_owners", kind: "enum", T: () => ["c1.api.app.v1.AppOwnersCount", AppOwnersCount], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 12, name: "user_statuses", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.user.v1.UserStatus", UserStatus] },
            { no: 13, name: "app_owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 14, name: "only_v2_connectors", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsExpandedRequest
 */
export const SearchAppsExpandedRequest = new SearchAppsExpandedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsExpandedResponse$Type extends MessageType<SearchAppsExpandedResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsExpandedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsExpandedResponse
 */
export const SearchAppsExpandedResponse = new SearchAppsExpandedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiGetAppResponse$Type extends MessageType<MultiGetAppResponse> {
    constructor() {
        super("c1.api.app.v1.MultiGetAppResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppView },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MultiGetAppResponse
 */
export const MultiGetAppResponse = new MultiGetAppResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MultiGetAppRequest$Type extends MessageType<MultiGetAppRequest> {
    constructor() {
        super("c1.api.app.v1.MultiGetAppRequest", [
            { no: 1, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 2, name: "expand_mask", kind: "message", T: () => AppExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MultiGetAppRequest
 */
export const MultiGetAppRequest = new MultiGetAppRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInactiveOwnersCountsRequest$Type extends MessageType<GetInactiveOwnersCountsRequest> {
    constructor() {
        super("c1.api.app.v1.GetInactiveOwnersCountsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetInactiveOwnersCountsRequest
 */
export const GetInactiveOwnersCountsRequest = new GetInactiveOwnersCountsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetInactiveOwnersCountsResponse$Type extends MessageType<GetInactiveOwnersCountsResponse> {
    constructor() {
        super("c1.api.app.v1.GetInactiveOwnersCountsResponse", [
            { no: 1, name: "apps_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "entitlements_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "resources_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetInactiveOwnersCountsResponse
 */
export const GetInactiveOwnersCountsResponse = new GetInactiveOwnersCountsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAndOwners$Type extends MessageType<AppAndOwners> {
    constructor() {
        super("c1.api.app.v1.AppAndOwners", [
            { no: 1, name: "app_view", kind: "message", T: () => AppView },
            { no: 2, name: "app_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAndOwners
 */
export const AppAndOwners = new AppAndOwners$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsWithDeactivatedOwnerRequest$Type extends MessageType<SearchAppsWithDeactivatedOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerRequest
 */
export const SearchAppsWithDeactivatedOwnerRequest = new SearchAppsWithDeactivatedOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppsWithDeactivatedOwnerResponse$Type extends MessageType<SearchAppsWithDeactivatedOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppAndOwners },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppsWithDeactivatedOwnerResponse
 */
export const SearchAppsWithDeactivatedOwnerResponse = new SearchAppsWithDeactivatedOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppSearchFilter$Type extends MessageType<AppSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppSearchFilter", [
            { no: 1, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 2, name: "ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 3, name: "exclude_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 4, name: "only_directories", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppSearchFilter
 */
export const AppSearchFilter = new AppSearchFilter$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.Apps
 */
export const Apps = new ServiceType("c1.api.app.v1.Apps", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App" }] } }, I: GetAppRequest, O: GetAppResponse },
    { name: "MultiGet", options: { "authz.method": { role: "VIEWER" } }, I: MultiGetAppRequest, O: MultiGetAppResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps", query: { page_size: "page_size", page_token: "page_token" }, group: "App" }] } }, I: ListAppsRequest, O: ListAppsResponse },
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App" }], group: "App" }] } }, I: CreateAppRequest, O: CreateAppResponse },
    { name: "CreateWithConnector", options: { "authz.method": { role: "OWNER" } }, I: CreateAppWithConnectorRequest, O: CreateAppResponse },
    { name: "CreateWithUnmanagedApp", options: { "authz.method": { role: "OWNER" } }, I: CreateAppWithUnmanagedRequest, O: CreateAppResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "App" }], group: "App" }] } }, I: UpdateAppRequest, O: UpdateAppResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App" }], group: "App" }] } }, I: DeleteAppRequest, O: DeleteAppResponse },
    { name: "SetAppIcon", options: { "authz.method": { role: "OWNER" } }, I: SetAppIconRequest, O: SetAppIconResponse },
    { name: "UpliftAppUsers", options: { "authz.method": { role: "OWNER" } }, I: UpliftAppUsersRequest, O: UpliftAppUsersResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppSearch
 */
export const AppSearch = new ServiceType("c1.api.app.v1.AppSearch", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/apps", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Apps", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: SearchAppsRequest, O: SearchAppsResponse },
    { name: "SearchAppsExpanded", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppsExpandedRequest, O: SearchAppsExpandedResponse },
    { name: "GetInactiveOwnersCounts", options: { "authz.method": { role: "VIEWER" } }, I: GetInactiveOwnersCountsRequest, O: GetInactiveOwnersCountsResponse },
    { name: "SearchAppsWithDeactivatedOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppsWithDeactivatedOwnerRequest, O: SearchAppsWithDeactivatedOwnerResponse }
]);
